import type { CsvRow } from '../csv/downloadCsv';
import { percentRemaining, percentUsed } from './revenueAnalytics.utils';
import type { RevenueAnalyticsRow } from './types';

export interface RevenueAnalyticsCsvColumnLabels {
    provider: string;
    symbol: string;
    qty: string;
    avgPrice: string;
    totalCost: string;
    curPrice: string;
    fairValue: string;
    sodInventory: string;
    remainingInventory: string;
    percentUsed: string;
    percentRemaining: string;
}

/**
 * Serialize the analytics rows to CSV row objects mirroring the table's
 * columns. Pure: the caller supplies the localized header labels. The
 * percent columns are exported in percent units (0-100) so spreadsheets
 * show the same figure the UI's bars read; `null` inventory data exports
 * as blank cells like the UI's placeholders.
 */
export function buildRevenueAnalyticsCsvRows(
    rows: ReadonlyArray<RevenueAnalyticsRow>,
    columnLabels: RevenueAnalyticsCsvColumnLabels,
): CsvRow[] {
    return rows.map((row) => {
        const pctUsed = percentUsed(row);
        const pctRem = percentRemaining(row);
        return {
            [columnLabels.provider]: row.providerName,
            [columnLabels.symbol]: row.symbol,
            [columnLabels.qty]: row.qty,
            [columnLabels.avgPrice]: row.avgPrice,
            [columnLabels.totalCost]: row.totalCost,
            [columnLabels.curPrice]: row.curPrice,
            [columnLabels.fairValue]: row.fairValue ?? '',
            [columnLabels.sodInventory]: row.sodInventory ?? '',
            [columnLabels.remainingInventory]: row.remainingInventory ?? '',
            [columnLabels.percentUsed]: pctUsed === null ? '' : pctUsed * 100,
            [columnLabels.percentRemaining]: pctRem === null ? '' : pctRem * 100,
        };
    });
}
